import {
  ArrayFilters,
  DefaultFilters,
  ListFilterTypeObject,
  WithOptionsFilterFilters,
} from '@/src/components/organism/Filter/types';
import { OPTIONS_CONST } from '@/src/constants/options';

export const administratorFilters: () => (
  | DefaultFilters
  | WithOptionsFilterFilters
  | ArrayFilters
)[] = () => [
  {
    key: 'id',
    label: 'ID',
    placeholder: 'ID를 입력해주세요',
  },
  {
    key: 'nameLike',
    label: '이름',
    placeholder: '이름을 입력해주세요',
  },
  {
    key: 'phoneLike',
    label: '핸드폰 번호',
    placeholder: '핸드폰번호를 입력해주세요',
  },
  {
    key: 'createdAt',
    label: '등록 일자',
    type: 'DATE_RANGE',
    rangeKeys: ['createdAtFrom', 'createdAtTo'],
  },
  {
    key: 'departmentLike',
    label: '소속',
    placeholder: '소속을 입력해주세요',
  },
  {
    key: 'isActivated',
    label: '사용 여부',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: OPTIONS_CONST.activated, value: 'true' },
      { label: OPTIONS_CONST.notActivated, value: 'false' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'aIdLike',
    label: '아이디(Email)',
    placeholder: '아이디 (Email)을 입력해주세요',
  },
];
